const FilterBar = ({ options, active, onToggle, showOutlet, onToggleOutlet, showOutletToggle }) => {
    return (
        <div className="filter-bar">
            { showOutletToggle &&
                <label className="filter-outlet-toggle">
                    <span className="filter-outlet-label">Mostrar productos Outlet</span>
                    <input
                        type="checkbox"
                        checked={showOutlet}
                        className="filter-outlet-checkbox"
                        onChange={(e) => onToggleOutlet(e.target.checked)}
                    />
                    <div className="filter-outlet-slider-container">
                        <span className="filter-outlet-slider"></span>
                    </div>
                </label>
            }
            { options && options.length > 0 &&
                <div className="filter-bar-buttons">
                    {options.map(opt => (
                        <button
                            key={opt.value}
                            type="button"
                            className={`filter-btn ${active === opt.value ? 'active' : ''}`}
                            onClick={() => onToggle(opt.value)}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            }
        </div>
    );
}

export default FilterBar;